import React, { useEffect, useState, useCallback } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  CardBody,
  Form,
  Input,
  Button,
  Label,
} from "reactstrap";
import Select from "react-select";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import CasoChecket from "../../assets/images/check.svg";

import {
  IoCheckmarkDoneSharp,
  IoPlaySharp,
  IoPauseSharp,
  IoStopSharp,
} from "react-icons/io5";
import SweetAlert from "react-bootstrap-sweetalert";
import Swal from "sweetalert2";
import "react-phone-input-2/lib/style.css";
import { connect, useSelector } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
//Import Breadcrumb
import Loader from "../../components/Common/Loader";
import Pagination from "../../components/Common/Pagination_ansync";
import "./Casos.css";
import { getAgent, getCasosFilter, getCasosList, postCasosStatusChange, postFinalizarCaso, getTipoCasos } from "../../helpers/backend";
import { generateActaVisitaPDFBlobWithoutImages, generateActaVisitaPDFBlob, generateActaAdicionalIndividualPDFBlob } from "../../components/ActaVisitaPDF";

import {
  TbLayoutList,
  TbLayoutGrid,
  TbSearch,
  TbLayoutListFilled,
  TbLayoutGridAdd,
} from "react-icons/tb";
import ListaCasos from "./components/ListaCasos";
import CalendarCasos from "./components/CalendarCasos";
import ButtonVolver from "../../components/ButtonVolver";
import CasosCensoModal from "../../components/CasosCensoModal";
import CorrespondenciaModal from "./components/CorrespondenciaModal";

const Casos = (props) => {
  const history = useHistory();

  // Persistencia de filtros aplicados
  const FILTER_STORAGE_KEY = "casosFilters";

  const [botonActivo, setBotonActivo] = useState("Todas");
  const [params, setParams] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  });
  const [viewCasos, setViewCasos] = useState(() => {
    return localStorage.getItem("viewCasos") || "card";
  });

  const [agent, setAgent] = useState({});
  const [agentOptions, setAgentOptions] = useState([]);
  const [agentesSelected, setAgentesSelected] = useState([]);

  // Helper para setear agentes seleccionados desde IDs guardados
  const setAgentesSelectedFromIds = useCallback(
    (ids) => {
      if (!Array.isArray(ids) || agentOptions.length === 0) return;
      const selected = ids
        .map((id) => agentOptions.find((o) => o.value === id))
        .filter(Boolean);
      setAgentesSelected(selected);
    },
    [agentOptions]
  );

  const getAgentData = async () => {
    const response = await getAgent();
    const data = response.data;
    setAgent(data);
    // Mapear agentes a opciones para el select (mostrar nombre pero enviar id)
    const options = Array.isArray(data)
      ? data.map((a) => ({
        value: a.id,
        label: a.full_name || a.get_full_name || a.username || `ID ${a.id}`,
      }))
      : [];
    setAgentOptions(options);
  };

  const getTipoCasosData = async () => {
    try {
      const response = await getTipoCasos();
      const tiposCaso = response.data.tipos_caso || [];
      const options = tiposCaso.map(tipo => ({
        value: tipo,
        label: tipo
      }));
      setTipoCasoOptions(options);
    } catch (error) {
      console.error('Error fetching tipos de caso:', error);
      setTipoCasoOptions([]);
    }
  };
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [codigoCau, setCodigoCau] = useState([]);
  const [tipoCaso, setTipoCaso] = useState("");
  const [estado, setEstado] = useState("");
  const [tipoOrden, setTipoOrden] = useState("");
  const [tipoProductor, setTipoProductor] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [tipoCasoOptions, setTipoCasoOptions] = useState([]);

  // Permisos de visualización del filtro de agentes
  const canSeeAgentFilter = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const groups = String(user?.groups);
      return (
        groups.includes("SuperAdmin") ||
        groups.includes("Administrador") ||
        groups.includes("Supervisor")
      );
    } catch (e) {
      return false;
    }
  };

  // Opciones para los selects
  const codigoCauOptions = [
    { value: "F1T", label: "F1T" },
    { value: "F2M", label: "F2M" },
    { value: "F3A", label: "F3A" },
    { value: "F4P", label: "F4P" },
    { value: "K1C", label: "K1C" },
    { value: "K2P", label: "K2P" },
    { value: "K3B", label: "K3B" },
    { value: "K4C", label: "K4C" },
    { value: "K5T", label: "K5T" },
    { value: "K6I", label: "K6I" }
  ];

  const tipoOrdenOptions = [
    { value: "RCD", label: "RCD" },
    { value: "PQRS", label: "PQRS" },
    { value: "PROCESOS COMERCIALES", label: "PROCESOS COMERCIALES" },
    { value: "CORRESPONDENCIA", label: "CORRESPONDENCIA" }
  ];

  // tipoCasoOptions is now loaded dynamically from API

  const estadoOptions = [
    { value: "SIN_ASIGNAR", label: "Sin Asignar" },
    { value: "EN_AFORO", label: "En Aforo" },
    { value: "PENDIENTE", label: "Pendiente" },
    { value: "EN_PROCESO", label: "En Proceso" },
    { value: "FINALIZADO", label: "Finalizado" }
  ];

  const tipoProductorOptions = [
    { value: "Pequ. Prod. Comercial", label: "Pequ. Prod. Comercial" },
    { value: "Gran Prod. Comercial <6", label: "Gran Prod. Comercial <6" },
    { value: "Residencial Estrato 3", label: "Residencial Estrato 3" },
    { value: "Residencial Estrato 2", label: "Residencial Estrato 2" },
    { value: "Gran Prod. Oficial <6", label: "Gran Prod. Oficial <6" },
    { value: "Pequ. Prod. Oficial", label: "Pequ. Prod. Oficial" },
    { value: "Gran Prod. Comercial >6", label: "Gran Prod. Comercial >6" },
    { value: "Multiusuario Residencial Estrato 3", label: "Multiusuario Residencial Estrato 3" },
    { value: "Multiusuario No Residencial Comercial", label: "Multiusuario No Residencial Comercial" },
    { value: "Residencial Estrato 4", label: "Residencial Estrato 4" },
    { value: "Gran Prod. Oficial >6", label: "Gran Prod. Oficial >6" },
    { value: "Residencial Estrato 1", label: "Residencial Estrato 1" },
    { value: "Multiusuario Residencial Estrato 2", label: "Multiusuario Residencial Estrato 2" },
    { value: "Multiusuario Residencial Estrato 4", label: "Multiusuario Residencial Estrato 4" },
    { value: "Multiusuario Residencial Estrato 5", label: "Multiusuario Residencial Estrato 5" },
    { value: "Residencial Estrato 5", label: "Residencial Estrato 5" },
    { value: "Pequ. Prod. Industrial", label: "Pequ. Prod. Industrial" },
    { value: "Multiusuario No Residencial Oficial", label: "Multiusuario No Residencial Oficial" },
    { value: "Residencial Estrato 6", label: "Residencial Estrato 6" }
  ];

  const [actionAlert, setActionAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);

  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [action, setAction] = useState("");
  const [ticket, setTicket] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [coordenadas, setCoordenadas] = useState("");
  const [ticketId, setTicketId] = useState(null);
  const [showCensoModal, setShowCensoModal] = useState(false);
  const [showCorrespondenciaModal, setShowCorrespondenciaModal] = useState(false);
  const [selectedCorrespondencia, setSelectedCorrespondencia] = useState(null);

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyFilters();
    }
  };

  const onCodigoCauChange = (selectedOptions) => {
    setCodigoCau(selectedOptions || []);
  };

  const onTipoCasoChange = (selectedOption) => {
    setTipoCaso(selectedOption ? selectedOption.value : "");
  };

  const onEstadoChange = (selectedOption) => {
    setEstado(selectedOption ? selectedOption.value : "");
  };

  const onTipoOrdenChange = (selectedOption) => {
    setTipoOrden(selectedOption ? selectedOption.value : "");
  };

  const onTipoProductorChange = (selectedOption) => {
    setTipoProductor(selectedOption ? selectedOption.value : "");
  };

  const onAgentesChange = (selectedOptions) => {
    setAgentesSelected(selectedOptions || []);
  };

  const onDateRangeChange = (value) => {
    // Formatea la fecha en horario local evitando desfases por UTC
    const formatDateLocal = (date) => {
      if (!date) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setDateRange(value);
    if (value && value.length === 2 && value[0] && value[1]) {
      const startDate = formatDateLocal(value[0]);
      const endDate = formatDateLocal(value[1]);
      // Si se selecciona el mismo día, ambos serán idénticos
      setFechaInicio(startDate);
      setFechaFin(endDate);
    } else {
      setFechaInicio("");
      setFechaFin("");
    }
  };

  // const BASE_URL = process.env.REACT_APP_API_URL;

  const theme = useSelector((state) => state.theme.theme) || "light";

  const handleViewCasos = (tipo_vista) => {
    localStorage.setItem("viewCasos", tipo_vista);
    setViewCasos(tipo_vista);
  };

  useEffect(() => {
    localStorage.setItem("viewCasos", viewCasos);
  }, [viewCasos]);

  // Removed automatic search effect - search now only triggers on Enter key or button click

  const buildFilterUrl = () => {
    const params = new URLSearchParams();

    if (search) params.append('search', search);
    if (codigoCau && codigoCau.length > 0) {
      const codigosCauString = codigoCau.map(option => option.value).join(',');
      params.append('codigo_cau', codigosCauString);
    }
    if (tipoCaso) params.append('tipo_caso', tipoCaso);
    if (estado) params.append('estado', estado);
    if (tipoOrden) params.append('tipo_orden', tipoOrden);
    if (tipoProductor) params.append('descripcion_tipoproductor', tipoProductor);
    if (agentesSelected && agentesSelected.length > 0) {
      const agentesString = agentesSelected.map(option => option.value).join(',');
      params.append('agentes', agentesString);
    }
    if (fechaInicio) params.append('fecha_inicio', fechaInicio);
    if (fechaFin) params.append('fecha_fin', fechaFin);

    return params.toString();
  };

  // Guardar filtros aplicados en localStorage
  const saveFiltersToStorage = useCallback(() => {
    const snapshot = {
      search,
      codigoCau: (codigoCau || []).map((o) => o.value),
      tipoCaso,
      estado,
      tipoOrden,
      tipoProductor,
      agentes: (agentesSelected || []).map((o) => o.value),
      fechaInicio,
      fechaFin,
      botonActivo,
    };
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(snapshot));
  }, [
    search,
    codigoCau,
    tipoCaso,
    estado,
    tipoOrden,
    tipoProductor,
    agentesSelected,
    fechaInicio,
    fechaFin,
    botonActivo,
  ]);

  // Cargar filtros guardados desde localStorage (si existen)
  const loadFiltersFromStorage = useCallback(() => {
    try {
      const raw = localStorage.getItem(FILTER_STORAGE_KEY);
      if (!raw) return null;
      const saved = JSON.parse(raw);
      setSearch(saved.search || "");
      setTipoCaso(saved.tipoCaso || "");
      setEstado(saved.estado || "");
      setTipoOrden(saved.tipoOrden || "");
      setTipoProductor(saved.tipoProductor || "");
      setFechaInicio(saved.fechaInicio || "");
      setFechaFin(saved.fechaFin || "");
      setBotonActivo(saved.botonActivo || "Todas");
      // Mapear valores a opciones para CAU
      const cauOpts = (saved.codigoCau || [])
        .map((val) => codigoCauOptions.find((o) => o.value === val))
        .filter(Boolean);
      setCodigoCau(cauOpts);
      // Agentes seleccionados se setean cuando existan agentOptions
      setAgentesSelectedFromIds(saved.agentes || []);
      return saved;
    } catch (e) {
      return null;
    }
  }, [codigoCauOptions, setAgentesSelectedFromIds]);

  // Refrescar lista manteniendo filtros actuales y el botón activo
  const refreshCasos = useCallback(async (override) => {
    setLoading(true);
    const buildFromSnapshot = (s) => {
      const p = new URLSearchParams();
      if (!s) return '';
      if (s.search) p.append('search', s.search);
      if (Array.isArray(s.codigoCau) && s.codigoCau.length > 0) {
        p.append('codigo_cau', s.codigoCau.join(','));
      }
      if (s.tipoCaso) p.append('tipo_caso', s.tipoCaso);
      if (s.estado) p.append('estado', s.estado);
      if (s.tipoOrden) p.append('tipo_orden', s.tipoOrden);
      if (s.tipoProductor) p.append('descripcion_tipoproductor', s.tipoProductor);
      if (Array.isArray(s.agentes) && s.agentes.length > 0) {
        p.append('agentes', s.agentes.join(','));
      }
      if (s.fechaInicio) p.append('fecha_inicio', s.fechaInicio);
      if (s.fechaFin) p.append('fecha_fin', s.fechaFin);
      return p.toString();
    };

    const filterParams = override ? buildFromSnapshot(override) : buildFilterUrl();
    let url;
    const estadoBase = override && override.botonActivo ? override.botonActivo : botonActivo;
    if (estadoBase === "Todas" || estadoBase === "Filtrado") {
      url = filterParams ? `?${filterParams}` : "";
    } else {
      url = `?estado=${estadoBase}${filterParams ? `&${filterParams}` : ""}`;
    }
    const response = await getCasosFilter(url);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  }, [botonActivo]);

  // Aplica el orden personalizado guardado en localStorage a un arreglo de resultados
  const getOrderedResults = (results) => {
    try {
      const isEnabled = localStorage.getItem('casosCustomOrderEnabled') === 'true';
      if (!isEnabled || !Array.isArray(results) || results.length === 0) {
        return results;
      }

      const saved = localStorage.getItem('casosCustomOrder');
      const customOrder = saved ? JSON.parse(saved) : [];
      if (!Array.isArray(customOrder) || customOrder.length === 0) {
        return results;
      }

      const dataMap = new Map(results.map(item => [item.id, item]));
      const usedIds = new Set();
      const ordered = [];

      // Primero, agregar los elementos según el orden guardado
      customOrder.forEach((id) => {
        if (dataMap.has(id)) {
          ordered.push(dataMap.get(id));
          usedIds.add(id);
        }
      });

      // Luego, agregar los que no estén en el orden guardado
      results.forEach((item) => {
        if (!usedIds.has(item.id)) {
          ordered.push(item);
        }
      });

      return ordered;
    } catch (error) {
      console.error('Error aplicando orden personalizado de casos:', error);
      return results;
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    applyFilters();
  };

  const applyFilters = async () => {
    setLoading(true);
    const filterParams = buildFilterUrl();

    let url;
    if (botonActivo === "Todas" || botonActivo === "Filtrado") {
      url = filterParams ? `?${filterParams}` : '';
      setBotonActivo(filterParams ? "Filtrado" : "Todas");
    } else {
      // Si hay un estado seleccionado, combinar con filtros usando el listado base
      url = `?estado=${botonActivo}${filterParams ? `&${filterParams}` : ''}`;
    }

    // Persistir filtros aplicados
    saveFiltersToStorage();

    const response = await getCasosFilter(url);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };

  const clearFilters = () => {
    setSearch("");
    setCodigoCau([]);
    setTipoCaso("");
    setEstado("");
    setTipoOrden("");
    setTipoProductor("");
    setAgentesSelected([]);
    setFechaInicio("");
    setFechaFin("");
    setDateRange([null, null]);
    setShowCalendar(false);
    setBotonActivo("Todas");
    // Limpiar filtros persistidos
    localStorage.removeItem(FILTER_STORAGE_KEY);
    // Remover cualquier parámetro de estado en la URL
    history.replace({ pathname: '/casos', search: '' });
    getCasosData();
  };

  // const resetSearch = async () => {
  //   setLoading(true);
  //   let url;
  //   if (botonActivo === "Todas") {
  //     url = `?search=`;
  //   } else {
  //     url = `casos/casos/casos_por_estado/?estado=${botonActivo}&search=`;
  //   }
  //   const response = await getCasosFilter(url);
  //   setParams({
  //     count: response.data.count,
  //     next: response.data.next,
  //     previous: response.data.previous,
  //     results: response.data.results,
  //   });
  //   setSearch("");
  //   setLoading(false);
  // };

  const getCasosData = async () => {
    setLoading(true);
    const response = await getCasosList();
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };
  const getCasosPorEstados = async (estadoSeleccionado) => {
    setLoading(true);
    setBotonActivo(estadoSeleccionado);

    // Actualizar el estado en el select también
    setEstado(estadoSeleccionado === "Todas" ? "" : estadoSeleccionado);

    let response;
    if (estadoSeleccionado === "Todas") {
      // Si es "Todas", obtener todos los casos
      response = await getCasosList();
    } else {
      // Usar el listado base con filtro por estado para mantener consistencia de campos
      const url = `?estado=${estadoSeleccionado}`;
      response = await getCasosFilter(url);
    }

    console.log(response);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    // Persistir cambios de estado y botón activo
    const snapshot = {
      search,
      codigoCau: (codigoCau || []).map((o) => o.value),
      tipoCaso,
      estado: estadoSeleccionado === "Todas" ? "" : estadoSeleccionado,
      tipoOrden,
      tipoProductor,
      agentes: (agentesSelected || []).map((o) => o.value),
      fechaInicio,
      fechaFin,
      botonActivo: estadoSeleccionado,
    };
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(snapshot));
    setLoading(false);
  };
  const getFilterData = async (url) => {
    setLoading(true);

    // Usar buildFilterUrl para mantener consistencia y combinar con parámetros de paginación
    const filterParams = buildFilterUrl();
    const urlParams = new URLSearchParams(url.startsWith('?') ? url.slice(1) : url);

    // Combinar filtros actuales con parámetros de paginación
    if (filterParams) {
      const filterUrlParams = new URLSearchParams(filterParams);
      for (const [key, value] of filterUrlParams) {
        if (!urlParams.has(key)) {
          urlParams.set(key, value);
        }
      }
    }

    const finalUrl = urlParams.toString() ? `?${urlParams.toString()}` : '';
    const response = await getCasosFilter(finalUrl);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };
  const getFilterCasosData = async (url) => {
    setLoading(true);

    // Preservar filtros actuales
    const urlParams = new URLSearchParams(url.startsWith('?') ? url.slice(1) : url);

    // Agregar filtros actuales si no están en la URL
    if (search && !urlParams.has('search')) {
      urlParams.set('search', search);
    }
    if (codigoCau && codigoCau.length > 0 && !urlParams.has('codigo_cau')) {
      const codigosCauString = codigoCau.map(option => option.value).join(',');
      urlParams.set('codigo_cau', codigosCauString);
    }
    if (tipoCaso && !urlParams.has('tipo_caso')) {
      urlParams.set('tipo_caso', tipoCaso);
    }
    if (estado && !urlParams.has('estado')) {
      urlParams.set('estado', estado);
    }
    if (tipoOrden && !urlParams.has('tipo_orden')) {
      urlParams.set('tipo_orden', tipoOrden);
    }
    if (tipoProductor && !urlParams.has('descripcion_tipoproductor')) {
      urlParams.set('descripcion_tipoproductor', tipoProductor);
    }
    if (agentesSelected && agentesSelected.length > 0 && !urlParams.has('agentes')) {
      const agentesString = agentesSelected.map(option => option.value).join(',');
      urlParams.set('agentes', agentesString);
    }
    if (fechaInicio && !urlParams.has('fecha_inicio')) {
      urlParams.set('fecha_inicio', fechaInicio);
    }
    if (fechaFin && !urlParams.has('fecha_fin')) {
      urlParams.set('fecha_fin', fechaFin);
    }

    // Construir URL final usando el listado base y filtro por estado
    const filterParams = urlParams.toString();
    const finalUrl = `?estado=${botonActivo}${filterParams ? `&${filterParams}` : ''}`;

    const response = await getCasosFilter(finalUrl);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });
    setLoading(false);
  };

  const handleAction = async (action, ticket, id) => {
    setAction(action);
    setTicket(ticket);
    setTicketId(id);

    if (!navigator.geolocation) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'La geolocalización no está soportada por este navegador.'
      });
      return;
    }

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      const { latitude, longitude } = position.coords;
      setCoordenadas(latitude + " " + longitude);
      setActionAlert(true);
    } catch (error) {
      console.error("Error obteniendo ubicación:", error);
      Swal.fire({
        icon: 'warning',
        title: 'Ubicación Requerida',
        text: 'Para continuar, es necesario autorizar el acceso a su ubicación. Por favor, habilite los permisos y vuelva a intentarlo.',
        confirmButtonColor: "#28a745",
      });
    }
  };

  const handleFinalizar = async (ticket, id, caso) => {
    setTicket(ticket);
    setTicketId(id);

    let currentCoords = "";
    if (!navigator.geolocation) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'La geolocalización no está soportada por este navegador.'
      });
      return;
    }

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      currentCoords = position.coords.latitude + " " + position.coords.longitude;
      setCoordenadas(currentCoords);
    } catch (error) {
      console.error("Error obteniendo ubicación:", error);
      Swal.fire({
        icon: 'warning',
        title: 'Ubicación Requerida',
        text: 'Para finalizar el caso, es OBLIGATORIO autorizar el acceso a su ubicación. Por favor, habilite los permisos y vuelva a intentarlo.',
        confirmButtonColor: "#28a745",
      });
      return;
    }

    // Primer modal: Elegir si enviar informe o no
    const { value: choice } = await Swal.fire({
      title: "Finalizar OT",
      text: "¿Cómo desea finalizar la orden de trabajo?",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Enviar informe al cliente",
      denyButtonText: "Finalizar sin enviar informe",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      denyButtonColor: "#ffc107",
      cancelButtonColor: "#6c757d",
      icon: "question"
    });

    if (!choice && choice !== false) {
      // Usuario canceló
      return;
    }

    let confirmed;

    if (choice === true) {
      // Usuario eligió enviar informe, mostrar modal con teléfono
      const defaultPhone = caso && caso.informe && caso.informe.representante_telefono_celular
        ? caso.informe.representante_telefono_celular
        : '';

      const div = document.createElement('div');
      div.innerHTML = `
        <div style="text-align: left; margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #495057;">
            Número de teléfono del cliente:
          </label>
          <div id="phone-input-container" style="text-align: left;"></div>
        </div>
      `;

      let phoneValue = '';

      const phoneResult = await Swal.fire({
        title: "Enviar informe al cliente",
        html: div.innerHTML,
        showCancelButton: true,
        confirmButtonText: "Enviar informe",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        didOpen: () => {
          const container = document.getElementById('phone-input-container');
          if (container) {
            container.innerHTML = `
              <div style="display: flex; border: 1px solid #ced4da; border-radius: 4px; overflow: hidden;">
                <select 
                  id="country-select" 
                  style="padding: 8px; border: none; background: #f8f9fa; border-right: 1px solid #ced4da; outline: none;"
                >
                  <option value="+57">🇨🇴 +57</option>
                  <option value="+1">🇺🇸 +1</option>
                  <option value="+52">🇲🇽 +52</option>
                  <option value="+34">🇪🇸 +34</option>
                  <option value="+54">🇦🇷 +54</option>
                  <option value="+56">🇨🇱 +56</option>
                  <option value="+51">🇵🇪 +51</option>
                  <option value="+58">🇻🇪 +58</option>
                  <option value="+593">🇪🇨 +593</option>
                  <option value="+591">🇧🇴 +591</option>
                </select>
                <input 
                  id="phone-input" 
                  type="tel" 
                  placeholder="300 123 4567"
                  value="${defaultPhone}"
                  style="flex: 1; padding: 8px 12px; border: none; outline: none; font-size: 14px;"
                />
              </div>
            `;

            const countrySelect = document.getElementById('country-select');
            const phoneInput = document.getElementById('phone-input');

            const formatPhoneNumber = (value) => {
              const numbers = value.replace(/\D/g, '');
              if (numbers.length <= 3) return numbers;
              if (numbers.length <= 6) return numbers.slice(0, 3) + ' ' + numbers.slice(3);
              return numbers.slice(0, 3) + ' ' + numbers.slice(3, 6) + ' ' + numbers.slice(6, 10);
            };

            if (defaultPhone) {
              const formatted = formatPhoneNumber(defaultPhone);
              phoneInput.value = formatted;
              phoneValue = '+57' + defaultPhone.replace(/\s/g, '');
            } else {
              phoneValue = '+57';
            }

            phoneInput.addEventListener('input', (e) => {
              const formatted = formatPhoneNumber(e.target.value);
              e.target.value = formatted;
              phoneValue = countrySelect.value + e.target.value.replace(/\s/g, '');
            });

            countrySelect.addEventListener('change', (e) => {
              phoneValue = e.target.value + phoneInput.value.replace(/\s/g, '');
            });

            phoneInput.focus();
          }
        },
        preConfirm: () => {
          if (!phoneValue || phoneValue.trim() === '+57' || phoneValue.trim() === '') {
            Swal.showValidationMessage('El número de teléfono es obligatorio');
            return false;
          }

          const numbersOnly = phoneValue.replace(/\D/g, '');

          if (numbersOnly.length < 10 || numbersOnly.length > 15) {
            Swal.showValidationMessage('Ingrese un número de teléfono válido (10-15 dígitos)');
            return false;
          }

          return { phone: numbersOnly, withReport: true };
        }
      });

      if (!phoneResult.value) {
        // Usuario canceló el modal de teléfono
        return;
      }

      confirmed = phoneResult.value;
    } else {
      // Usuario eligió finalizar sin enviar informe
      confirmed = { phone: '', withReport: false };
    }

    if (confirmed) {
      try {
        // Preparar FormData para envío
        const formData = new FormData();
        // Agregar coordenadas obligatoriamente
        formData.append('coordenadas', currentCoords);

        // Si se va a enviar informe, generar y adjuntar PDF
        if (confirmed.withReport) {
          formData.append('phone', confirmed.phone);
          // Obtener datos del informe para generar PDF
          const informe = caso && caso.informe ? caso.informe : {};

          // Preparar datos para el PDF
          const actaData = {
            // Información básica
            fecha_visita: informe.fecha_visita || new Date().toISOString().split('T')[0],
            hora_visita: informe.hora_visita || new Date().toTimeString().slice(0, 5),
            ciudad_visita: informe.ciudad_visita || 'Bogotá',
            dia_visita: informe.dia_visita || new Date().getDate().toString(),
            mes_visita: informe.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
            año_visita: informe.año_visita || new Date().getFullYear().toString(),
            archivo_no: informe.archivo_no || '',
            no_pqrs: informe.no_de_pqrs || caso.numero_reclamo || '',
            cuenta_suscriptor: informe.cuenta_suscriptor || '',
            cuenta_energia: informe.cuenta_energia || '',
            direccion: informe.direccion || caso.cliente?.[0].address?.[0].address || '',
            nombre_cliente: informe.nombre_cliente || caso.cliente?.[0]?.full_name || '',

            // Datos del predio
            direccion_predio: informe.direccion_predio || '',
            estrato_predio: informe.estrato_predio || '',
            localidad_predio: informe.localidad_predio || '',
            actualizacion_nombre_suscriptor: informe.actualizacion_nombre_suscriptor || '',

            // Tablas dinámicas
            unidades_residenciales_detalle: informe.unidades_residenciales_detalle ?
              (typeof informe.unidades_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_residenciales_detalle) :
                informe.unidades_residenciales_detalle) : [],
            producto_nombre: informe.producto_nombre || '',
            producto_detalle: informe.producto_detalle ?
              (typeof informe.producto_detalle === 'string' ?
                JSON.parse(informe.producto_detalle) :
                informe.producto_detalle) : [],
            unidades_no_residenciales_detalle: informe.unidades_no_residenciales_detalle ?
              (typeof informe.unidades_no_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_no_residenciales_detalle) :
                informe.unidades_no_residenciales_detalle) : [],
            producto_unr: informe.producto_unr || '',
            recipientes_detalle: informe.recipientes_detalle ?
              (typeof informe.recipientes_detalle === 'string' ?
                JSON.parse(informe.recipientes_detalle) :
                informe.recipientes_detalle) : [],

            // Características del predio
            abandonado: informe.abandonado || false,
            suscriptor_inactivo: informe.suscriptor_inactivo || false,
            demolido: informe.demolido || false,
            en_construccion: informe.en_construccion || false,
            en_remodelacion: informe.en_remodelacion || false,
            inexistente: informe.inexistente || false,
            inhabitable_o_en_ruinas: informe.inhabitable_o_en_ruinas || false,
            lote: informe.lote || false,
            minimas_condiciones: informe.minimas_condiciones || false,
            programa_del_icbf: informe.programa_del_icbf || false,
            descuento_puerta_a_puerta: informe.descuento_puerta_a_puerta || false,
            se_cierra_pqr_como_no_atendido: informe.se_cierra_pqr_como_no_atendido || false,
            areas_comunes: informe.areas_comunes || false,
            predio_que_se_observa_vacio: informe.predio_que_se_observa_vacio || false,
            predio_se_observa_ocupado: informe.predio_se_observa_ocupado || false,
            cuenta_suscriptor_activo: informe.cuenta_suscriptor_activo || false,
            causa_demolicion: informe.causa_demolicion || "",
            suscriptor_activo_detalles: informe.suscriptor_activo_detalles || "",

            // Tipos de residuos
            tipos_residuos: {
              escombros: informe.escombros || false,
              especiales: informe.especiales || false,
              para_reuso: informe.para_relleno || false,
              para_escombrera: informe.para_escombrera || false,
              enlonado: informe.enlonado || false,
              a_granel: informe.a_granel || false
            },
            tipo_recoleccion: informe.tipo_recoleccion || '',
            m3_gratis: informe.m3_gratis || false,
            dos_m3_gratis: (informe.dos_m3_gratis ?? informe['2m3_gratis']) || false,
            cancelado: informe.cancelado || false,
            valor_m3: informe.valor_m3 || '',

            // Observaciones y representantes
            observaciones: informe.observaciones || '',
            representante_nombre: informe.representante_nombre || caso.cliente?.[0]?.full_name || '',
            representante_cedula: informe.representante_cedula || caso.cliente?.[0]?.documentNumber || '',
            representante_firma: informe.representante_firma,
            representante_telefono_celular: informe.representante_telefono_celular || '',
            ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
            ciudad_limpia_codigo: informe.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
            ciudad_limpia_firma: informe.ciudad_limpia_firma,
            ciudad_limpia_telefono: informe.ciudad_limpia_telefono || '',
            anotaciones: informe.anotaciones || '',
            sin_firma: informe.sin_firma || false,
          };

          // Generar PDF como blob SIN imágenes para envío por WhatsApp
          const pdfResult = await generateActaVisitaPDFBlobWithoutImages(actaData, caso, caso.informes_adicionales || []);

          if (pdfResult.success) {
            // Crear archivo con nombre específico
            const fileName = `Acta_Visita_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
            const pdfFile = new File([pdfResult.blob], fileName, { type: 'application/pdf' });
            formData.append('pdf_file', pdfFile);
            // Generar PDF adicional CON imágenes (evidencias) y adjuntarlo
            const evidenciasResult = await generateActaVisitaPDFBlob(actaData, caso, caso.informes_adicionales || []);
            if (evidenciasResult.success) {
              const evidenciasFileName = `Acta_Visita_Evidencias_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
              const evidenciasFile = new File([evidenciasResult.blob], evidenciasFileName, { type: 'application/pdf' });
              formData.append('informe_pdf_evidencias', evidenciasFile);
            } else {
              console.error('Error generando PDF con evidencias:', evidenciasResult.error);
            }
          } else {
            throw new Error('Error generando PDF: ' + pdfResult.error);
          }
        } else {
          // Si no se envía el informe, phone vacío pero sí generar PDF
          formData.append('phone', '');

          // Generar y adjuntar PDF aunque no se envíe por WhatsApp
          // Obtener datos del informe para generar PDF
          const informe = caso && caso.informe ? caso.informe : {};

          // Preparar datos para el PDF
          const actaData = {
            // Información básica
            fecha_visita: informe.fecha_visita || new Date().toISOString().split('T')[0],
            hora_visita: informe.hora_visita || new Date().toTimeString().slice(0, 5),
            ciudad_visita: informe.ciudad_visita || 'Bogotá',
            dia_visita: informe.dia_visita || new Date().getDate().toString(),
            mes_visita: informe.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
            año_visita: informe.año_visita || new Date().getFullYear().toString(),
            archivo_no: informe.archivo_no || '',
            no_pqrs: informe.no_de_pqrs || caso.numero_reclamo || '',
            cuenta_suscriptor: informe.cuenta_suscriptor || '',
            cuenta_energia: informe.cuenta_energia || '',
            direccion: informe.direccion || caso.cliente?.[0].address?.[0].address || '',
            nombre_cliente: informe.nombre_cliente || caso.cliente?.[0]?.full_name || '',

            // Datos del predio
            direccion_predio: informe.direccion_predio || '',
            estrato_predio: informe.estrato_predio || '',
            localidad_predio: informe.localidad_predio || '',
            actualizacion_nombre_suscriptor: informe.actualizacion_nombre_suscriptor || '',

            // Tablas dinámicas
            unidades_residenciales_detalle: informe.unidades_residenciales_detalle ?
              (typeof informe.unidades_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_residenciales_detalle) :
                informe.unidades_residenciales_detalle) : [],
            producto_nombre: informe.producto_nombre || '',
            producto_detalle: informe.producto_detalle ?
              (typeof informe.producto_detalle === 'string' ?
                JSON.parse(informe.producto_detalle) :
                informe.producto_detalle) : [],
            unidades_no_residenciales_detalle: informe.unidades_no_residenciales_detalle ?
              (typeof informe.unidades_no_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_no_residenciales_detalle) :
                informe.unidades_no_residenciales_detalle) : [],
            producto_unr: informe.producto_unr || '',
            recipientes_detalle: informe.recipientes_detalle ?
              (typeof informe.recipientes_detalle === 'string' ?
                JSON.parse(informe.recipientes_detalle) :
                informe.recipientes_detalle) : [],

            // Características del predio
            abandonado: informe.abandonado || false,
            suscriptor_inactivo: informe.suscriptor_inactivo || false,
            demolido: informe.demolido || false,
            en_construccion: informe.en_construccion || false,
            en_remodelacion: informe.en_remodelacion || false,
            inexistente: informe.inexistente || false,
            inhabitable_o_en_ruinas: informe.inhabitable_o_en_ruinas || false,
            lote: informe.lote || false,
            minimas_condiciones: informe.minimas_condiciones || false,
            programa_del_icbf: informe.programa_del_icbf || false,
            descuento_puerta_a_puerta: informe.descuento_puerta_a_puerta || false,
            se_cierra_pqr_como_no_atendido: informe.se_cierra_pqr_como_no_atendido || false,
            areas_comunes: informe.areas_comunes || false,
            predio_que_se_observa_vacio: informe.predio_que_se_observa_vacio || false,
            predio_se_observa_ocupado: informe.predio_se_observa_ocupado || false,
            cuenta_suscriptor_activo: informe.cuenta_suscriptor_activo || false,
            causa_demolicion: informe.causa_demolicion || "",
            suscriptor_activo_detalles: informe.suscriptor_activo_detalles || "",

            // Tipos de residuos
            tipos_residuos: {
              escombros: informe.escombros || false,
              especiales: informe.especiales || false,
              para_reuso: informe.para_relleno || false,
              para_escombrera: informe.para_escombrera || false,
              enlonado: informe.enlonado || false,
              a_granel: informe.a_granel || false
            },
            tipo_recoleccion: informe.tipo_recoleccion || '',
            m3_gratis: informe.m3_gratis || false,
            dos_m3_gratis: (informe.dos_m3_gratis ?? informe['2m3_gratis']) || false,
            cancelado: informe.cancelado || false,
            valor_m3: informe.valor_m3 || '',

            // Observaciones y representantes
            observaciones: informe.observaciones || '',
            nombre_cliente: informe.nombre_cliente || '',
            direccion_informe: informe.direccion_informe || '',
            representante_nombre: informe.representante_nombre || '',
            representante_cedula: informe.representante_cedula || '',
            representante_firma: informe.representante_firma,
            representante_telefono_celular: informe.representante_telefono_celular || '',
            ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
            ciudad_limpia_codigo: informe.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
            ciudad_limpia_firma: informe.ciudad_limpia_firma,
            ciudad_limpia_telefono: informe.ciudad_limpia_telefono || '',
            anotaciones: informe.anotaciones || '',
            sin_firma: informe.sin_firma || false,
          };

          // Generar PDF como blob SIN imágenes para envío por WhatsApp
          const pdfResult = await generateActaVisitaPDFBlobWithoutImages(actaData, caso, caso.informes_adicionales || []);

          if (pdfResult.success) {
            // Crear archivo con nombre específico
            const fileName = `Acta_Visita_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
            const pdfFile = new File([pdfResult.blob], fileName, { type: 'application/pdf' });
            formData.append('pdf_file', pdfFile);
            // Generar PDF adicional CON imágenes (evidencias) y adjuntarlo
            const evidenciasResult = await generateActaVisitaPDFBlob(actaData, caso, caso.informes_adicionales || []);
            if (evidenciasResult.success) {
              const evidenciasFileName = `Acta_Visita_Evidencias_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
              const evidenciasFile = new File([evidenciasResult.blob], evidenciasFileName, { type: 'application/pdf' });
              formData.append('informe_pdf_evidencias', evidenciasFile);
            } else {
              console.error('Error generando PDF con evidencias:', evidenciasResult.error);
            }
          } else {
            throw new Error('Error generando PDF: ' + pdfResult.error);
          }
        }

        // Generar PDFs individuales para actas adicionales
        if (caso.informes_adicionales && caso.informes_adicionales.length > 0) {
          for (const adicional of caso.informes_adicionales) {
            // Mapear datos del acta adicional
            const actaAdicionalData = {
              // Información básica
              fecha_visita: adicional.fecha_visita || caso.informe?.fecha_visita || new Date().toISOString().split('T')[0],
              hora_visita: adicional.hora_visita || caso.informe?.hora_visita || new Date().toTimeString().slice(0, 5),
              ciudad_visita: adicional.ciudad_visita || caso.informe?.ciudad_visita || 'Bogotá',
              dia_visita: adicional.dia_visita || caso.informe?.dia_visita || new Date().getDate().toString(),
              mes_visita: adicional.mes_visita || caso.informe?.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
              año_visita: adicional.año_visita || caso.informe?.año_visita || new Date().getFullYear().toString(),
              archivo_no: adicional.archivo_no || '',
              no_pqrs: adicional.no_de_pqrs || '',
              cuenta_suscriptor: adicional.cuenta_suscriptor || '',
              cuenta_energia: adicional.cuenta_energia || '',
              direccion: adicional.direccion || caso.cliente?.[0]?.address?.[0]?.address || '',
              nombre_cliente: adicional.nombre_cliente || caso.cliente?.[0]?.full_name || '',
              direccion_informe: adicional.direccion_informe || '',

              // Datos del predio
              direccion_predio: adicional.direccion_predio || '',
              estrato_predio: adicional.estrato_predio || '',
              localidad_predio: adicional.localidad_predio || '',
              actualizacion_nombre_suscriptor: adicional.actualizacion_nombre_suscriptor || '',

              // Tablas dinámicas
              unidades_residenciales_detalle: adicional.unidades_residenciales_detalle ?
                (typeof adicional.unidades_residenciales_detalle === 'string' ?
                  JSON.parse(adicional.unidades_residenciales_detalle) :
                  adicional.unidades_residenciales_detalle) : [],
              producto_nombre: adicional.producto_nombre || '',
              producto_detalle: adicional.producto_detalle ?
                (typeof adicional.producto_detalle === 'string' ?
                  JSON.parse(adicional.producto_detalle) :
                  adicional.producto_detalle) : [],
              unidades_no_residenciales_detalle: adicional.unidades_no_residenciales_detalle ?
                (typeof adicional.unidades_no_residenciales_detalle === 'string' ?
                  JSON.parse(adicional.unidades_no_residenciales_detalle) :
                  adicional.unidades_no_residenciales_detalle) : [],
              producto_unr: adicional.producto_unr || '',
              recipientes_detalle: adicional.recipientes_detalle ?
                (typeof adicional.recipientes_detalle === 'string' ?
                  JSON.parse(adicional.recipientes_detalle) :
                  adicional.recipientes_detalle) : [],

              // Características del predio
              abandonado: adicional.abandonado || false,
              suscriptor_inactivo: adicional.suscriptor_inactivo || false,
              demolido: adicional.demolido || false,
              en_construccion: adicional.en_construccion || false,
              en_remodelacion: adicional.en_remodelacion || false,
              inexistente: adicional.inexistente || false,
              inhabitable_o_en_ruinas: adicional.inhabitable_o_en_ruinas || false,
              lote: adicional.lote || false,
              minimas_condiciones: adicional.minimas_condiciones || false,
              programa_del_icbf: adicional.programa_del_icbf || false,
              descuento_puerta_a_puerta: adicional.descuento_puerta_a_puerta || false,
              se_cierra_pqr_como_no_atendido: adicional.se_cierra_pqr_como_no_atendido || false,
              areas_comunes: adicional.areas_comunes || false,
              predio_que_se_observa_vacio: adicional.predio_que_se_observa_vacio || false,
              predio_se_observa_ocupado: adicional.predio_se_observa_ocupado || false,
              cuenta_suscriptor_activo: adicional.cuenta_suscriptor_activo || false,
              causa_demolicion: adicional.causa_demolicion || "",
              suscriptor_activo_detalles: adicional.suscriptor_activo_detalles || "",

              // Tipos de residuos
              tipos_residuos: {
                escombros: adicional.escombros || false,
                especiales: adicional.especiales || false,
                para_reuso: adicional.para_relleno || false,
                para_escombrera: adicional.para_escombrera || false,
                enlonado: adicional.enlonado || false,
                a_granel: adicional.a_granel || false
              },
              tipo_recoleccion: adicional.tipo_recoleccion || '',
              valor_m3: adicional.valor_m3 || '',
              m3_gratis: adicional.m3_gratis || false,
              dos_m3_gratis: (adicional.dos_m3_gratis ?? adicional['2m3_gratis']) || false,
              cancelado: adicional.cancelado || false,

              // Observaciones y representantes
              observaciones: adicional.observaciones || '',
              representante_nombre: adicional.representante_nombre || caso.cliente?.[0]?.full_name || '',
              representante_cedula: adicional.representante_cedula || caso.cliente?.[0]?.documentNumber || '',
              representante_firma: adicional.representante_firma,
              representante_telefono_celular: adicional.representante_telefono_celular || '',
              ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
              ciudad_limpia_codigo: adicional.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
              ciudad_limpia_firma: adicional.ciudad_limpia_firma,
              ciudad_limpia_telefono: adicional.ciudad_limpia_telefono || '',
              anotaciones: adicional.anotaciones || '',
              sin_firma: adicional.sin_firma || false,
            };

            // Preparar datos del caso modificados para incluir las imágenes del acta adicional
            const casoParaPDFAdicional = {
              ...caso,
              informe: {
                ...(caso.informe || {}),
                images: adicional.images || []
              }
            };

            // Generar PDF para esta acta adicional usando el nuevo componente especializado
            const pdfAdicionalResult = await generateActaAdicionalIndividualPDFBlob(actaAdicionalData, casoParaPDFAdicional);

            if (pdfAdicionalResult.success) {
              const fileNameAdicional = `Acta_Adicional_${adicional.id}_${caso.numero_reclamo || 'documento'}.pdf`;
              const pdfFileAdicional = new File([pdfAdicionalResult.blob], fileNameAdicional, { type: 'application/pdf' });
              formData.append(`informe_pdf_adicional_${adicional.id}`, pdfFileAdicional);
            } else {
              console.error(`Error generando PDF para acta adicional ${adicional.id}:`, pdfAdicionalResult.error);
            }
          }
        }

        const response = await postFinalizarCaso(id, formData);

        console.log("Respuesta del backend:", response);

        if (response.status === 200 || response.status === 206) {
          const successMessage = confirmed.withReport
            ? "El caso ha sido finalizado exitosamente con informe"
            : "El caso ha sido finalizado exitosamente sin enviar informe";

          Swal.fire({
            title: "OT Finalizada!",
            text: successMessage,
            icon: "success",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#28a745",
          }).then(() => {
            getCasosData();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Hubo un problema al finalizar la OT",
            icon: "error",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#dc3545"
          });
        }
      } catch (error) {
        console.error("Error al finalizar OT:", error);
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al finalizar el OT",
          icon: "error",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#dc3545"
        });
      }
    }
  };

  const actionSuccess = async () => {
    const response = await postCasosStatusChange(ticketId, {
      accion: action,
      observaciones: observaciones,
      coordenadas: coordenadas,
    });

    if (response.status === 200) {
      setActionAlert(false);
      setShowAlertSuccess(true);
    } else {
      setErrorAlert(true);
      setActionAlert(false);
    }
  };

  useEffect(() => {
    // Leer parámetros para detectar navegación desde el dashboard
    const paramsUrl = new URLSearchParams(history.location.search);
    const sourceParam = paramsUrl.get('source');
    const estadoParam = paramsUrl.get('estado');

    if (sourceParam === 'dashboard' && estadoParam) {
      // Navegación proveniente del dashboard: ignorar snapshot persistido SOLO en esta carga inicial
      setEstado(estadoParam === 'Todas' ? '' : estadoParam);
      setBotonActivo(estadoParam);
      if (estadoParam === 'Todas') {
        getCasosData();
      } else {
        getCasosPorEstados(estadoParam);
      }
      getAgentData();
      getTipoCasosData();
      return;
    }

    // Intentar cargar filtros persistidos para visitas normales
    const saved = loadFiltersFromStorage();
    if (saved) {
      refreshCasos(saved);
      getAgentData();
      getTipoCasosData();
      return;
    }

    // Si no hay persistencia, usar parámetro estado si existe
    if (estadoParam && estadoParam !== 'Todas') {
      setEstado(estadoParam);
      setBotonActivo(estadoParam);
      getCasosPorEstados(estadoParam);
    } else {
      getCasosData();
    }

    getAgentData();
    getTipoCasosData();
  }, []);

  // Mantener la URL sincronizada si se cambia el estado manualmente
  useEffect(() => {
    const paramsUrl = new URLSearchParams(history.location.search);
    const fromDashboard = paramsUrl.get('source') === 'dashboard';

    if (botonActivo && botonActivo !== 'Todas') {
      paramsUrl.set('estado', botonActivo);
      if (fromDashboard) {
        // Mantener marcador de origen
        paramsUrl.set('source', 'dashboard');
      }
      history.replace({ pathname: '/casos', search: `?${paramsUrl.toString()}` });
    } else {
      // Quitar estado; preservar source si venía del dashboard
      paramsUrl.delete('estado');
      if (!fromDashboard) {
        history.replace({ pathname: '/casos', search: '' });
      } else {
        history.replace({ pathname: '/casos', search: `?${paramsUrl.toString()}` });
      }
    }
  }, [botonActivo]);

  // Aplicar selección de agentes guardada cuando las opciones estén listas
  useEffect(() => {
    const raw = localStorage.getItem(FILTER_STORAGE_KEY);
    if (raw) {
      try {
        const saved = JSON.parse(raw);
        setAgentesSelectedFromIds(saved.agentes || []);
      } catch (e) {
        // ignore
      }
    }
  }, [agentOptions, setAgentesSelectedFromIds]);

  // Escuchar eventos de modificación de datos para refrescar la lista
  useEffect(() => {
    const handler = () => {
      refreshCasos();
    };
    window.addEventListener("casos:dataModified", handler);
    return () => window.removeEventListener("casos:dataModified", handler);
  }, [refreshCasos]);

  function Status({ estado }) {
    const estados = {
      EN_PAUSA: { className: "bg-info", text: "En Pausa" },
      PENDIENTE: { className: "bg-danger", text: "Pendiente" },
      EN_AFORO: { className: "bg-pink ", text: "En Aforo" },
      EN_PROCESO: { background: "#6f42c1", text: "En Proceso" },
      FINALIZADO: { background: "#09cc09", text: "Finalizado" },
      SIN_ASIGNAR: { className: "bg-warning", text: "Sin Asignar" },
      ASIGNADO: { className: "bg-primary", text: "Asignado" },
    };

    const estadoActual = estados[estado] || {
      className: "bg-secondary",
      text: estado || "Sin Estado",
      background: "#6c757d"
    };

    return (
      <div
        className={`badge rounded-pill ${estadoActual.className || ''} font-size-12`}
        style={{ background: estadoActual.background }}
      >
        <strong>{estadoActual.text}</strong>
      </div>
    );
  }
  console.log(params);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Cuidad Limpia | OT </title>
        </MetaTags>
        <Col className="d-flex gap-3 mb-3 align-items-center">
          <ButtonVolver />
          <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>OT</span>
        </Col>
        <Container fluid>
          {/* Render Breadcrumbs
          <Breadcrumbs title="Cuidad Limpia" breadcrumbItem=" Casos" /> */}

          {actionAlert ? (
            <SweetAlert
              title={`¿${action} ${ticket} ?`}
              warning
              showConfirm={true}
              confirmBtnText="Si"
              showCancel={true}
              cancelBtnBsStyle="danger"
              cancelBtnText="No"
              onCancel={() => setActionAlert(false)}
              onConfirm={() => actionSuccess()}
            >
              <Label>Observaciones</Label>
              <Input
                type="textarea"
                id="observaciones"
                name="observaciones"
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </SweetAlert>
          ) : null}
          {showAlertSuccess ? (
            <SweetAlert
              title="Hecho!"
              success
              showConfirm={false}
              timeout={2000}
              onConfirm={() => {
                getCasosData();
                setShowAlertSuccess(false);
              }}
            ></SweetAlert>
          ) : null}
          {errorAlert ? (
            <SweetAlert
              title="Error!"
              danger
              showConfirm={false}
              timeout={2000}
              onConfirm={() => {
                getCasosData();
                setErrorAlert(false);
              }}
            ></SweetAlert>
          ) : null}
          {loading ? (
            <Loader />
          ) : (
            <div>
              <CardBody className="p-2">
                <div className="filters-section p-2 bg-light rounded">
                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    {/* Búsqueda */}
                    <div style={{ flex: '1 1 200px', minWidth: '200px', maxWidth: '300px' }}>
                      <Form onSubmit={onSubmit} className="m-0">
                        <div className="position-relative">
                          <input
                            type="text"
                            className={`form-control form-control-sm ${theme === "dark" ? "input_search_casos_dark" : ""}`}
                            name="search"
                            placeholder="Buscar..."
                            value={search}
                            onChange={onChange}
                            onKeyPress={onKeyPress}
                            style={{
                              borderRadius: '4px',
                              padding: '4px 30px 4px 8px',
                              fontSize: '12px',
                              height: '28px'
                            }}
                          />
                          <button
                            type="submit"
                            className="btn btn-link p-0"
                            style={{
                              border: 'none',
                              background: 'none',
                              position: 'absolute',
                              right: '5px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              color: '#6c757d'
                            }}
                          >
                            <TbSearch size={14} />
                          </button>
                        </div>
                      </Form>
                    </div>

                    {/* Código CAU */}
                    <div style={{ flex: '1 1 120px', minWidth: '120px' }}>
                      <Select
                        value={codigoCau}
                        onChange={onCodigoCauChange}
                        options={codigoCauOptions}
                        placeholder="CAU"
                        isClearable
                        isMulti
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '28px',
                            height: 'auto',
                            fontSize: '12px',
                            borderRadius: '4px',
                            padding: '0'
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: '0 4px'
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: '2px'
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 10000 })
                        }}
                      />
                    </div>

                    {/* Tipo de Orden */}
                    <div style={{ flex: '1 1 130px', minWidth: '130px' }}>
                      <Select
                        value={tipoOrdenOptions.find(option => option.value === tipoOrden) || null}
                        onChange={onTipoOrdenChange}
                        options={tipoOrdenOptions}
                        placeholder="Tipo Orden"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '28px',
                            height: '28px',
                            fontSize: '12px',
                            borderRadius: '4px'
                          }),
                          valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                          dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                          menuPortal: (base) => ({ ...base, zIndex: 10000 })
                        }}
                      />
                    </div>

                    {/* Fuente */}
                    <div style={{ flex: '1 1 130px', minWidth: '130px' }}>
                      <Select
                        value={tipoCasoOptions.find(option => option.value === tipoCaso) || null}
                        onChange={onTipoCasoChange}
                        options={tipoCasoOptions}
                        placeholder="Fuente"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '28px',
                            height: '28px',
                            fontSize: '12px',
                            borderRadius: '4px'
                          }),
                          valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                          dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                          menuPortal: (base) => ({ ...base, zIndex: 10000 })
                        }}
                      />
                    </div>

                    {/* Agentes */}
                    {canSeeAgentFilter() && (
                      <div style={{ flex: '1 1 130px', minWidth: '130px' }}>
                        <Select
                          value={agentesSelected}
                          onChange={onAgentesChange}
                          options={agentOptions}
                          placeholder="Agentes"
                          isClearable
                          isMulti
                          menuPortalTarget={document.body}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '28px',
                              height: 'auto',
                              fontSize: '12px',
                              borderRadius: '4px'
                            }),
                            valueContainer: (base) => ({ ...base, padding: '0 4px' }),
                            dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                            menuPortal: (base) => ({ ...base, zIndex: 10000 })
                          }}
                        />
                      </div>
                    )}

                    {/* Estado */}
                    <div style={{ flex: '1 1 120px', minWidth: '120px' }}>
                      <Select
                        value={estadoOptions.find(option => option.value === estado) || null}
                        onChange={onEstadoChange}
                        options={estadoOptions}
                        placeholder="Estado"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '28px',
                            height: '28px',
                            fontSize: '12px',
                            borderRadius: '4px'
                          }),
                          valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                          dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                          menuPortal: (base) => ({ ...base, zIndex: 10000 })
                        }}
                      />
                    </div>

                    {/* Tipo Productor */}
                    <div style={{ flex: '1 1 130px', minWidth: '130px' }}>
                      <Select
                        value={tipoProductorOptions.find(option => option.value === tipoProductor) || null}
                        onChange={onTipoProductorChange}
                        options={tipoProductorOptions}
                        placeholder="Productor"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '28px',
                            height: '28px',
                            fontSize: '12px',
                            borderRadius: '4px'
                          }),
                          valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                          dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                          menuPortal: (base) => ({ ...base, zIndex: 10000 })
                        }}
                      />
                    </div>

                    {/* Rango de Fechas */}
                    <div className="position-relative" style={{ flex: '0 0 auto' }}>
                      <Button
                        color="outline-secondary"
                        size="sm"
                        onClick={() => setShowCalendar(!showCalendar)}
                        className="text-start d-flex align-items-center justify-content-between text-truncate"
                        style={{ fontSize: '12px', height: '28px', padding: '0 10px', minWidth: '160px' }}
                      >
                        <span className="text-truncate" style={{ maxWidth: '140px' }}>
                          {dateRange[0] && dateRange[1]
                            ? `${dateRange[0].toLocaleDateString()} - ${dateRange[1].toLocaleDateString()}`
                            : "Fechas"}
                        </span>
                      </Button>
                      {showCalendar && (
                        <div
                          className="position-absolute shadow p-2 bg-white rounded border"
                          style={{ top: '100%', left: 0, zIndex: 1000, width: '280px' }}
                        >
                          <Calendar
                            onChange={onDateRangeChange}
                            value={dateRange}
                            selectRange={true}
                            className="react-calendar-custom border-0"
                          />
                          <div className="d-flex justify-content-end gap-2 mt-2 pt-2 border-top">
                            <Button color="secondary" size="sm" onClick={() => {
                              setDateRange([null, null]);
                              setFechaInicio("");
                              setFechaFin("");
                              setShowCalendar(false);
                            }} style={{ fontSize: '11px' }}>
                              Limpiar
                            </Button>
                            <Button color="primary" size="sm" onClick={() => setShowCalendar(false)} style={{ fontSize: '11px' }}>
                              Aplicar
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Botones Aplicar/Limpiar */}
                    <div className="d-flex gap-1">
                      <button onClick={applyFilters} className="btn btn-primary btn-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} title="Aplicar Filtros">
                        <TbSearch size={14} />
                      </button>
                      <button onClick={clearFilters} className="btn btn-outline-secondary btn-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} title="Limpiar Filtros">
                        <span style={{ fontSize: '16px', lineHeight: 1 }}>×</span>
                      </button>
                    </div>

                    {/* Botones Globales (Agregar, Vistas) */}
                    <div className="ms-auto d-flex gap-2">
                      <Button
                        color="success"
                        size="sm"
                        className="d-flex align-items-center gap-1"
                        style={{ height: '28px', fontSize: '12px' }}
                        onClick={() => setShowCensoModal(true)}
                      >
                        <TbLayoutGridAdd size={14} />
                        <span className="d-none d-md-inline">Nueva OT</span>
                      </Button>
                      <div className="btn-group">
                        <button
                          className={`btn btn-sm ${viewCasos === 'card' ? 'btn-success' : 'btn-outline-success'}`}
                          style={{ height: '28px', padding: '0 8px' }}
                          onClick={() => handleViewCasos("card")}
                          title="Vista de Tarjetas"
                        >
                          <TbLayoutGrid size={14} />
                        </button>
                        <button
                          className={`btn btn-sm ${viewCasos === 'list' ? 'btn-success' : 'btn-outline-success'}`}
                          style={{ height: '28px', padding: '0 8px' }}
                          onClick={() => handleViewCasos("list")}
                          title="Vista de Lista"
                        >
                          <TbLayoutList size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>

              {/*BOTONES DE FILTROS*/}

              {viewCasos === "card" && (
                <div className="card-container">
                  {(getOrderedResults(params.results) || []).map((casos) => {
                    // const imgUrl =
                    //   casos.images &&
                    //   casos.images[0] &&
                    //   `${BASE_URL.replace("/api", "")}${
                    //     casos.images[0].image
                    //   }`;
                    return (
                      <>
                        <div className={`ticket card_background ${casos.tipo_orden === 'CORRESPONDENCIA' ? 'ticket-correspondencia' : ''}`}>
                          <div>
                            <div
                              className="ticket-header position-relative"
                              style={{
                                backgroundColor:
                                  casos.estado === "FINALIZADO"
                                    ? "#09ce0933"
                                    : casos.estado === "EN_AFORO"
                                      ? "#ffcbf2"
                                      : casos.estado === "EN_PROCESO"
                                        ? "#915eef33"
                                        : casos.estado === "ASIGNADO"
                                          ? "#49b0ea4d"
                                          : casos.estado === "PENDIENTE"
                                            ? "#bf1b2133"
                                            : casos.estado === "SIN_ASIGNAR"
                                              ? "#e16b2033"
                                              : casos.estado === "EN_PAUSA"
                                                ? "#3272b133"
                                                : "",
                              }}
                            >
                              {/* Número de OT discreto en el header */}
                              <div className="position-absolute top-0 start-0 ms-2 ">
                                <span
                                  style={{
                                    fontSize: "14px",
                                    opacity: 0.7,
                                    color: "#2c3e50",
                                    fontWeight: "800"
                                  }}
                                >
                                  {casos.name ? casos.name.replace(/^Caso\s/, 'OT ') : ''}
                                </span>
                              </div>

                              {/* Badge de estado en la esquina superior derecha */}
                              <div className="position-absolute top-0 end-0 me-2 mt-1">
                                {casos.estado ? (
                                  <div style={{ fontSize: "12px", fontWeight: "600" }}>
                                    <Status estado={casos.estado} />
                                  </div>
                                ) : null}
                              </div>
                            </div>

                            {/* Banner de Vencimiento (Visible y con prioridad) */}
                            {casos.fecha_vencimiento && casos.estado !== "FINALIZADO" && (() => {
                              const d = new Date(casos.fecha_vencimiento).toISOString().slice(0, 10);
                              const today = new Date().toISOString().slice(0, 10);
                              const diffDays = Math.ceil((new Date(d) - new Date(today)) / (1000 * 60 * 60 * 24));

                              if (d < today) {
                                return (
                                  <div style={{ backgroundColor: '#dc3545', color: '#fff', textAlign: 'center', fontSize: '10.5px', fontWeight: '800', padding: '4px 0', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                    <i className="fas fa-exclamation-triangle me-1"></i> VENCIDO ({casos.fecha_vencimiento})
                                  </div>
                                );
                              } else if (diffDays >= 0 && diffDays <= 2) {
                                return (
                                  <div style={{ backgroundColor: '#ffc107', color: '#322601', textAlign: 'center', fontSize: '10.5px', fontWeight: '800', padding: '4px 0', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                    <i className="fas fa-clock me-1"></i> PRÓXIMO ({casos.fecha_vencimiento})
                                  </div>
                                );
                              }
                              return null;
                            })()}

                            <div
                              onClick={() => {
                                if (casos.tipo_orden === 'CORRESPONDENCIA') {
                                  setSelectedCorrespondencia(casos);
                                  setShowCorrespondenciaModal(true);
                                } else {
                                  history.push(`/casos/view/${casos.id}`);
                                }
                              }}
                              className="ticket-body"
                            >


                              {/* Encabezado principal de la tarjeta (condicional para PROCESOS COMERCIALES) */}
                              <div
                                style={{ height: "50px", marginBottom: "0px" }}
                                className="content_name_caso"
                              >
                                {casos?.tipo_orden === "PROCESOS COMERCIALES" ? (
                                  <>
                                    <p
                                      className="mb-1"
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: theme === "dark" ? "#fff" : "#2c3e50",
                                        lineHeight: "1.2"
                                      }}
                                    >
                                      Procesos Comerciales
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: theme === "dark" ? "#adb5bd" : "#6c757d",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {casos.tipo_caso}
                                    </p>
                                  </>
                                ) : casos?.tipo_orden === "CORRESPONDENCIA" ? (
                                  <>
                                    <p
                                      className="mb-1"
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: theme === "dark" ? "#fff" : "#28a745",
                                        lineHeight: "1.2"
                                      }}
                                    >
                                      Correspondencia
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: theme === "dark" ? "#adb5bd" : "#6c757d",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {casos.name ? casos.name.replace('Caso ', '') : "Sin Guía"}
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p
                                      className="mb-1"
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: theme === "dark" ? "#fff" : "#2c3e50",
                                        lineHeight: "1.2"
                                      }}
                                    >
                                      {casos.numero_reclamo || "Sin número de reclamo"}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: theme === "dark" ? "#adb5bd" : "#6c757d",
                                        fontWeight: "500"
                                      }}
                                    >
                                      Reclamo N°
                                    </p>
                                  </>
                                )}
                              </div>

                              <div className="content_info_caso_card">
                                {casos.tipo_orden === 'CORRESPONDENCIA' ? (
                                  <>
                                    <div className="content_title_info_caso">
                                      <span className="font-size-12">Reclamante:</span>
                                      <span className="font-size-12">Dirección:</span>
                                      <span className="font-size-12">Motivo:</span>
                                      <span className="font-size-12">Tipo de OT:</span>
                                      <span className="font-size-12">Planilla:</span>
                                    </div>
                                    <div className="content_info_caso">
                                      <span className="font-size-12" title={casos.metadata?.correspondencia?.nombre_reclamante || ""}>
                                        {casos.metadata?.correspondencia?.nombre_reclamante ?
                                          (casos.metadata.correspondencia.nombre_reclamante.length > 25 ?
                                            casos.metadata.correspondencia.nombre_reclamante.substring(0, 25) + "..." :
                                            casos.metadata.correspondencia.nombre_reclamante)
                                          : "Sin Reclamante"}
                                      </span>
                                      <span className="font-size-12" title={casos.metadata?.correspondencia?.direccion_reclamante || ""}>
                                        {casos.metadata?.correspondencia?.direccion_reclamante ?
                                          (casos.metadata.correspondencia.direccion_reclamante.length > 25 ?
                                            casos.metadata.correspondencia.direccion_reclamante.substring(0, 25) + "..." :
                                            casos.metadata.correspondencia.direccion_reclamante)
                                          : "Sin Dirección"}
                                      </span>
                                      <span className="font-size-12">
                                        {casos.metadata?.correspondencia?.motivo || "Sin Motivo"}
                                      </span>
                                      <span className="font-size-12">
                                        {casos.tipo_orden}
                                      </span>
                                      <span className="font-size-12">
                                        {casos.metadata?.correspondencia?.planilla || "N/A"}
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="content_title_info_caso">
                                      <span className="font-size-12">
                                        Cliente:
                                      </span>
                                      <span className="font-size-12">
                                        Dirección:
                                      </span>
                                      <span className="font-size-12">
                                        Agente:
                                      </span>
                                      <span className="font-size-12">
                                        Tipo de OT:
                                      </span>
                                      <span className="font-size-12">
                                        Fuente:
                                      </span>
                                      <span className="font-size-12">
                                        Código CAU:
                                      </span>
                                      <span className="font-size-12">
                                        Cuenta CL:
                                      </span>
                                      <span className="font-size-12">
                                        Cuenta Enel:
                                      </span>
                                      <span className="font-size-12">
                                        Tipo Productor:
                                      </span>
                                    </div>

                                    <div className="content_info_caso">
                                      <span
                                        className="font-size-12 cliente-info"
                                        title={casos.cliente && casos.cliente.length > 0 ? (
                                          Array.isArray(casos.cliente) ?
                                            casos.cliente[0].get_full_name || casos.cliente[0].full_name || "Sin nombre"
                                            : "Sin cliente"
                                        ) : (
                                          "Sin cliente asignado"
                                        )}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (casos.cliente && casos.cliente.length > 0) {
                                            const nombreCliente = Array.isArray(casos.cliente) ?
                                              casos.cliente[0].get_full_name || casos.cliente[0].full_name || "Sin nombre" : "Sin cliente";
                                            Swal.fire({
                                              title: 'Cliente',
                                              text: nombreCliente,
                                              confirmButtonText: 'Cerrar',
                                              confirmButtonColor: '#2fa4e7',
                                            });
                                          }
                                        }}
                                      >
                                        {casos.cliente && casos.cliente.length > 0 ? (
                                          Array.isArray(casos.cliente) ?
                                            casos.cliente[0].get_full_name || casos.cliente[0].full_name || "Sin nombre"
                                            : "Sin cliente"
                                        ) : (
                                          "Sin cliente asignado"
                                        )}
                                      </span>

                                      {/* Dirección del cliente */}
                                      <span
                                        className="font-size-12"
                                        title={casos.cliente && casos.cliente[0] && casos.cliente[0].address && casos.cliente[0].address[0] ? casos.cliente[0].address[0].address : "Sin dirección"}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const direcciones = [];
                                          if (casos.cliente && casos.cliente[0] && casos.cliente[0].address) {
                                            casos.cliente[0].address.forEach((addr, index) => {
                                              if (addr.address) {
                                                direcciones.push(`${addr.label || `Dirección ${index + 1}`}: ${addr.address}`);
                                              }
                                            });
                                          }

                                          if (direcciones.length > 0) {
                                            Swal.fire({
                                              title: 'Direcciones',
                                              html: direcciones.join('<br>'),
                                              confirmButtonText: 'Cerrar',
                                              confirmButtonColor: '#2fa4e7',
                                            });
                                          }
                                        }}
                                        style={{ cursor: (casos.cliente && casos.cliente[0] && casos.cliente[0].address && casos.cliente[0].address[0]) ? 'pointer' : 'default' }}
                                      >
                                        {casos.cliente && casos.cliente[0] && casos.cliente[0].address && casos.cliente[0].address[0] ? (
                                          casos.cliente[0].address[0].address.length > 25 ?
                                            `${casos.cliente[0].address[0].address.substring(0, 25)}...` :
                                            casos.cliente[0].address[0].address
                                        ) : "Sin dirección"}
                                        {casos.cliente && casos.cliente[0] && casos.cliente[0].address && casos.cliente[0].address.length > 1 && (
                                          <small style={{ color: '#007bff', marginLeft: '5px' }}>
                                            (+{casos.cliente[0].address.length - 1} más)
                                          </small>
                                        )}
                                      </span>

                                      {/* Agente - solo full_name */}
                                      <span className="font-size-12">
                                        {casos.contacto && casos.contacto.length > 0 ? (
                                          Array.isArray(casos.contacto) ?
                                            casos.contacto[0].full_name || "Sin nombre"
                                            : "Sin agente"
                                        ) : (
                                          "Sin agente asignado"
                                        )}
                                      </span>
                                      <span className="font-size-12">
                                        {casos.tipo_orden || "Sin fuente"}
                                      </span>
                                      <span className="font-size-12">
                                        {casos.tipo_caso || "Sin tipo"}
                                      </span>

                                      {/* Nuevos campos solicitados */}
                                      <span className="font-size-12" style={{ fontWeight: '500', color: theme === 'dark' ? '#17a2b8' : '#007bff' }}>
                                        {casos.cliente && casos.cliente.length > 0 && casos.cliente[0].codigoCAU ?
                                          casos.cliente[0].codigoCAU : "Sin código CAU"}
                                      </span>

                                      <span className="font-size-12" style={{ fontWeight: '500', color: theme === 'dark' ? '#28a745' : '#198754' }}>
                                        {casos.cliente && casos.cliente.length > 0 && casos.cliente[0].cuenta_contrato_ciudad_limpia ?
                                          casos.cliente[0].cuenta_contrato_ciudad_limpia : "Sin cuenta CL"}
                                      </span>

                                      <span className="font-size-12" style={{ fontWeight: '500', color: theme === 'dark' ? '#ffc107' : '#fd7e14' }}>
                                        {casos.cliente && casos.cliente.length > 0 && casos.cliente[0].cuenta_enel ?
                                          casos.cliente[0].cuenta_enel : "Sin cuenta Enel"}
                                      </span>

                                      <span className="font-size-12" style={{ fontWeight: '500', color: theme === 'dark' ? '#e83e8c' : '#d63384' }}>
                                        {casos.cliente && casos.cliente.length > 0 && casos.cliente[0].descripcion_tipoproductor ?
                                          casos.cliente[0].descripcion_tipoproductor : "Sin tipo productor"}
                                      </span>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div >
                      </>
                    );
                  })}
                </div>
              )}
              {viewCasos === "list" && <ListaCasos params={params} onDataModified={refreshCasos} />}
              {viewCasos === "calendar" && <CalendarCasos />}
            </div>
          )}
          {viewCasos !== "calendar" && (
            <div style={{ padding: "1rem 2rem" }}>
              <Pagination
                count={params.count}
                next={params.next}
                previous={params.previous}
                limit={100}
                filter={true}
                baseUrl="/casos/casos/"
                filterFunction={getFilterData}
              />
            </div>
          )}
        </Container>

        {/* Modal para crear censo */}
        <CasosCensoModal
          isOpen={showCensoModal}
          toggle={() => setShowCensoModal(false)}
          onSuccess={() => {
            setShowCensoModal(false);
            getCasosData(); // Refrescar la lista de casos
          }}
        />

        <CorrespondenciaModal
          isOpen={showCorrespondenciaModal}
          toggle={() => setShowCorrespondenciaModal(false)}
          caso={selectedCorrespondencia}
          onUpdate={refreshCasos}
        />
      </div >
    </React.Fragment >
  );
};
const mapStateToProps = (state) => {
  const { error, loading, casos } = state.Casos;
  return { error, loading, casos };
};

export default withRouter(connect(mapStateToProps)(Casos));
